import React from 'react';
import { Conversation } from '@/widget/domain/conversation';
import { humanizeDate } from '@/lib/datetime/humanizeDate';
import Avatar from '@/widget/ui/components/conversations/Avatar';
import styles from './ListItem.module.scss';

interface Props {
  conversation: Conversation
  openConversation: (key: string) => void;
}
function ListItem({ conversation, openConversation }: Props) {
  const htmlSafeMessage = conversation.lastMessage.text.replaceAll('<br>', ' ');

  return (
    <div
      className={styles.conversation}
      onClick={() => openConversation(conversation.key)}
    >
      <div className={styles.avatar}>
        <Avatar sender={conversation.lastMessage?.sender} />
      </div>
      <div className={styles.content}>
        <div className={styles.message}>
          {conversation.lastMessage.text.length ? htmlSafeMessage : window.ChatWidget.i18n.t('chat_widget.attach')}
        </div>
        <div className={styles.meta}>
          {conversation.lastMessage.fromOperator ? conversation.lastMessage.sender.workPosition : window.ChatWidget.i18n.t('chat_widget.you')}
          ,
          {' '}
          {humanizeDate(conversation.date)}
        </div>
      </div>
    </div>
  );
}

export default ListItem;
